import { Icon } from '@/shared/components'
import { TreeWidgetType } from '@/shared/components/Mosaic'
import { TREE_WIDGETS } from '@/shared/components/Mosaic/models/widgetType'
import { faMailboxFlagUp } from '@fortawesome/pro-regular-svg-icons'
import { faCarSide, faFileLines, faTruck } from '@fortawesome/pro-solid-svg-icons'

export const getIconFromNodeType = (widgetType: TreeWidgetType, uiColor?: string, isCourierModel?: boolean) => {
  if (widgetType === TREE_WIDGETS.PlanningShiftTable || widgetType === TREE_WIDGETS.RunsheetShiftTable) {
    return <Icon sx={{ width: '14px', height: '14px', color: uiColor }} icon={isCourierModel ? faCarSide : faTruck} />
  } else if (widgetType === TREE_WIDGETS.ScenarioUnassignedOrders || widgetType === TREE_WIDGETS.RunsheetUnassignedOrders) {
    return <Icon sx={{ width: '14px', height: '14px', color: uiColor }} icon={faFileLines} />
  } else if (widgetType === TREE_WIDGETS.Inbox) {
    return <Icon sx={{ width: '18px', height: '18px', paddingLeft: '4px' }} icon={faMailboxFlagUp} />
  }

  return null
}
